exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".certificate-inventory--title {\n  font-size: 16px;\n}\n\nbutton.certificate-intentory--tab-disabled.Mui-disabled {\n  background-color: rgba(0, 0, 0, 0.03);\n  cursor: not-allowed;\n  pointer-events: initial;\n}", ""]);

